import {
  ContactUsActionTypes,
  IAgentSupportTicketMetadata,
  IContactUsSubmissionFields,
  ISupportTicketResponse
} from 'src/state/contactus/types';
import { action } from 'typesafe-actions';
import { ICountryCode } from '../shared';

export const contactusResourcesRequest = () => action(ContactUsActionTypes.CONTACT_RESOURCES_REQUEST);
export const contactusResourcesSuccess = (countryCodes: ICountryCode[] | undefined) =>
  action(ContactUsActionTypes.CONTACT_RESOURCES_SUCCESS, { countryCodes });
export const contactusResourcesError = (error: string) => action(ContactUsActionTypes.CONTACT_RESOURCES_ERROR, error);

export const createSupportTicket = (
  contactUsPayload: IContactUsSubmissionFields,
  agentMetadata?: IAgentSupportTicketMetadata
) =>
  agentMetadata
    ? action(ContactUsActionTypes.CONTACTUS_CREATESUPPORTTICKET, contactUsPayload, agentMetadata)
    : action(ContactUsActionTypes.CONTACTUS_CREATESUPPORTTICKET, contactUsPayload);
export const createSupportTicketSuccess = (
  supportTicketResponse: ISupportTicketResponse | undefined,
  supportTicketEmail: string
) =>
  action(ContactUsActionTypes.CONTACTUS_CREATESUPPORTTICKET_SUCCESS, { supportTicketResponse, supportTicketEmail });
export const createSupportTicketError = (fieldErrors?: Record<string, string>) =>
  action(ContactUsActionTypes.CONTACTUS_CREATESUPPORTTICKET_ERROR, { fieldErrors });
export const setAddHeroBarListener = (value: boolean) => action(ContactUsActionTypes.SET_ADD_HERO_BAR_LISTENER, value);

